import Menu, { type MenuProps } from '@mui/material/Menu';
import { alpha, styled } from '@mui/material/styles';

export const IconsMenu = styled((props: MenuProps) => (
  <Menu elevation={0} {...props} />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    marginTop: 6,
    minWidth: 180,
    border: `1px solid ${(theme.vars ?? theme).palette.divider}`,
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 2px 8px rgba(0,0,0,0.04)',
    color: (theme.vars ?? theme).palette.text.primary,
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root, & > svg': {
        fontSize: 18,
        width: 18,
        height: 18,
        color: (theme.vars ?? theme).palette.text.secondary,
        flexShrink: 0,
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));
